module.exports = "<div class=pre-loader> <div class=pre-loader__inner> <div class=pre-loader__text> <img :src=\"'images/separator.svg'\" alt=\"\"/> <p> Uncover a destination <br> like no other while discovering <br> the secret to longevity. </p> <img :src=\"'images/separator.svg'\" alt=\"\"/> </div> <div class=pre-loader__canvas> <canvas resize=true hidpi=off id=canvas-1></canvas> <div class=canvas-after>&nbsp;</div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pre-loader/template.html
// module id = 34
// module chunks = 1